import { render } from "./CustomersViews.vue?vue&type=template&id=3d515985&scoped=true"
import script from "./CustomersViews.vue?vue&type=script&lang=js"
export * from "./CustomersViews.vue?vue&type=script&lang=js"

import "./CustomersViews.vue?vue&type=style&index=0&id=3d515985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d515985"]])

export default __exports__